/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
import Typography from "@fdn/typography";
import getSlugbrand from "Helpers/handleSlugBrand";
import TabsButton from "components/button/tabsButton";
import CardReviewSkeleton from "components/skeleton/card_review/cardReview";
import {
	beautyLevelHandle, handleImage, imageDynamic, imageDynamic2,
} from "Helpers/utils";
import dynamic from "next/dynamic";
import { useSelector } from "react-redux";

const ReviewCard = dynamic(
	() => import("@fdn/review_card"), {
		ssr: true,
	},
);

const Mobile = (props) => {

	const storeData = useSelector((state) => state);

	const prop = props;

	return (
		<>
			<div className="home-top">
				<Typography
					id_element="highlight-review"
					type="type-1"
					text="TRENDING REVIEWS"
					color="#F3BDCA"
					font_family="Poppins"
					font_size={29}
					font_weight={600}
					stroke_color="#454F5B"
					stroke_width="0.480209px"
					tail={false}
				/>
				<div className="tabs-container">
					{prop.tabList.map((data, idx) => (

						<TabsButton
							key={idx}
							isMobile={prop.isMobile}
							name={data.title}
							type={data.type}
							tabChoose={prop.tabChoose}
							handleChangeTabs={prop.handleChangeTabs}
						/>

					))}
				</div>
			</div>

			{
				storeData.storeReview.is_loading && !prop.newestReviews.on_load
					? (
						<div className="reviews-list-shimmer">
							{
								Array.from({ length: 5 }, (_index, idx) => (
									<div key={idx}>
										<CardReviewSkeleton isMobile />
										<hr style={{ height: "15px", border: "none", background: "#dfe3e8" }} />
									</div>

								))
							}
						</div>
					) : storeData.storeReview.data && prop.newestReviews.data.length > 0 ? (
						<div className="reviews-list-trending">
							{prop.newestReviews.data.map((review, idx) => (

								<div
									id={`id_${review.id}`}
									className={prop.newestReviews.data.length - 1 === idx ? "home-reviewcard-last" : "home-reviewcard"}
									key={review.id}
								>

									<ReviewCard
										key={review.id}
										is_mobile={prop.isMobile}
										type="1"
										product={{
											...review.product,
											image: review.product.image.match(
												/image.femaledaily.com/,
											)
												? imageDynamic2(review.product.image, 250)
												: imageDynamic(review.product.image, 250),
										}}
										product_url={`${process.env.NEXT_PUBLIC_REVIEWS_DOMAIN}/products/${review?.product.category?.parent?.slug}/${review?.product.category?.slug}/${review?.product?.brand?.slug}/${review.product.slug}`}
										brand_url={`${process.env.NEXT_PUBLIC_REVIEWS_DOMAIN}/brands/${getSlugbrand(review.product?.brand)}`}
										product_photos={review.photos}
										handle_product_photos={(data) => prop.handleImageView(data, review.photos)}
										brand_name={review.product?.brand.name}
										profile={review.user}
										self={prop.self.data}
										sso_domain={process.env.NEXT_PUBLIC_SSO_DOMAIN}
										profile_url={`${process.env.NEXT_PUBLIC_SSO_DOMAIN}/user/fd/${review.user.username}`}
										profile_image={handleImage(
											review.user.picture,
											100,
											"user",
										)}
										profile_age={(
											<div className="profile-info">
												{`${review.user.age_range}`}
												{" "}
												・
												<img
													className="beauty-level__image"
													width={14}
													height={14}
													src={`https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/web-assets/beauty-level/levels/${beautyLevelHandle(review.user.beauty_level)}.png`}
													alt={`icon-${beautyLevelHandle(review.user.beauty_level)}`}
												/>
												<p className="beauty-level">
													{beautyLevelHandle(review.user.beauty_level)}
												</p>
											</div>
										)}
										profile_description={`${
											review.user.skin.type ? `${review.user.skin.type}, ` : ""
										}${review.user.skin.tone ? review.user.skin.tone : ""}${
											review.user.skin.undertone
												? `, ${review.user.skin.undertone}`
												: ""
										}`}
										review={review}
										review_recommended={review.is_recommended}
										open_login={prop.open_login}
										handle_like={prop.handle_like}
										expand_text={prop.handleExpandText}
										open_report={prop.handleOpenReport}
										goto_add_review={() => prop.goToEditReview({
											id: review.id,
											slug: review.product.slug,
										})}
										// for comments
										toggle_comment={prop.toggle_comment}
										is_more_comments={(review?.comments?.data?.length < review.total_comments)}
										load_comments={prop.load_comments}
										handle_input={prop.handle_input}
										handle_comment={prop.handle_comment}
										comment_count_id={`comment-count-${review.id}`}
										comment_form_id={`comment-form-${review.id}`}
										comment_submit_id={`comment-button-${review.id}`}
									/>

								</div>

							))}

							{
								prop.newestReviews.on_load && (
									<CardReviewSkeleton isMobile />
								)
							}

							<div className="loadmore">
								{
									!prop.newestReviews.on_load
									&& prop.newestReviews.data.length < prop.newestReviews.total
										? (
											<button
												type="button"
												className="loadmore-button"
												onClick={prop.handleLoadMore}
												id="id-loadmore"
											>
												LOAD MORE REVIEWS
											</button>
										) : null
								}
							</div>

						</div>
					) : (
						<div className="error-container">
							<img className="asset-err" src="https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/web-assets/error/404.png" alt="error 500" />
							<div className="desc">
								<p className="text-title">Uh oh!</p>
								<p className="text-desc">Something went wrong.</p>
								<p className="text-desc">Try to refresh this page or feel free to contact us if the problem persists.</p>
							</div>
						</div>
					)
			}

			<style>
				{`
						@media screen and (max-width:320px){
							.reviews-list-trending .card-profile-wrapper .text-wrapper {
								max-width: 224px;
							}
						}
						.form-group {
							display: flex;
						}
						.review-card .text-right {
							text-align: right;
							justify-content: end;
						}
						.loadmore {
							width: 100%;
							display: flex;
							justify-content: center;
							margin: ${!prop.newestReviews.on_load && prop.newestReviews.data.length < prop.newestReviews.total ? "24px 0" : "0"};
							padding: 9px auto;
						}
						.loadmore-button{
							width: 100%;
							font-family: 'Poppins';
							font-style: normal;
							font-weight: 600;
							font-size: 16px;
							line-height: 24px;
							text-align: center;
							text-transform: capitalize;
							color: #DB284E;
							text-decoration: none;
							background: none;
							border: none;
							cursor: pointer
						}
						.profile-info {
							display: flex;
							align-items: center;
							gap: 4px;
						}
						.beauty-level {
							font-family: 'Roboto';
							font-style: normal;
							font-weight: 400;
							font-size: 14px !important;
							line-height: 22px;
							color: #919EAB;
							text-transform: capitalize;
						}
						.profile-review {
							font-family: 'Roboto';
							font-style: normal;
							font-weight: 700;
							font-size: 12px;
							line-height: 16px;
							color: #DB284E;
						}

						.reviews-list-trending .product-card .text-wrapper .product-brand{
							font-weight: 600;
							font-size: 14px;
						}
						.reviews-list-trending .product-card .text-wrapper p{
							font-weight: 400;
							font-size: 14px;
						}
						.reviews-list-trending .product-card .rating-wrapper .rating-text{
							font-weight: 400;
							font-size: 12px;
						}
						.reviews-list-trending .card-profile-wrapper .text-wrapper .profile-username{
							font-weight: 600;
							font-size: 16px;
						}
						.reviews-list-trending .card-profile-wrapper .text-wrapper .profile-age{
							font-weight: 400;
							font-size: 14px;
							color: #919EAB;
						}
						.reviews-list-trending .card-profile-wrapper .text-wrapper .profile-description{
							font-weight: 500;
							font-size: 14px;
							color: #919EAB;

							white-space: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;
						}
						.reviews-list-trending .review-card .recommend{
							font-weight: 500;
							font-size: 14px;
						}
						.reviews-list-trending .review-card .text-content{
							font-weight: 400;
							font-size: 16px;
						}
						.reviews-list-trending .review-card .information-wrapper p{
							font-size: 14px;
						}
						.reviews-list-trending .product-card .text-wrapper .product-shade{
							font-weight: 400;
							font-size: 14px;
						}
						.reviews-list-trending .card-profile-wrapper .image-wrapper{
							width: 60px;
    						height: 60px;
						}
						
					`}
			</style>

			<style jsx>
				{`
				.reviews-list-shimmer {
						width: 100%;
						max-width: 480px;
						margin: 0 auto;
				}
				.reviews-list-trending {
						width: 100%;
						max-width: 480px;
						margin: 0 auto;
				}
				.home-reviewcard {
						padding: 15px;
						position: relative;
						width: 92%;
						border-bottom: 20px solid #F0F3F7;
						max-width: 480px;
				}
				.home-reviewcard-last {
						padding: 15px;
						position: relative;
						width: 92%;
						border-bottom: 0px solid #F0F3F7;
						max-width: 480px;
				}
				.container{
						display: flex;
						flex-direction: column;
						align-items: center;
				}
				.home-top {
						width: 92%;
						margin: 0 auto 16px auto;
						max-width: 480px;
				}
				.tabs-container {
					margin-top: 16px;
					display: flex;
					gap: 8px;

					overflow-x: scroll;
					overflow-y: hidden;
					white-space: nowrap;

					overflow: -moz-scrollbars-none;
					-ms-overflow-style: none;
				}
				.tabs-container::-webkit-scrollbar { 
					width: 0 !important 
				}
				.error-container {
					display: flex;
					flex-direction: column;
					max-width: 480px;
					align-items: center;
					padding: 16px;
				}
				.asset-err{
						width:200px;
				}
				.desc{
						text-align: center;
				}
				.text-desc {
						font-family: Roboto;
						font-weight: 400;
						font-size: 14px;
						line-height: 34px;
						letter-spacing: 0em;
						color: #454F5B;
						margin-top: 0;
				}
				.text-title {
						font-family: Poppins;
						font-weight: 600;
						font-size: 16px;
						line-height: 42px;
						letter-spacing: 0em;
						margin-bottom: 0;
				}
      `}
			</style>

			<style>
				{`
					.review-card .card-profile-wrapper {
							align-items: flex-start;
					}
        `}
			</style>

			<style jsx global="true">
				{`
					.banner_mobile_sb2 {
							// margin: 20px auto 20px auto;
							text-align: center;
					}

					.profile-wrapper p {
							margin-top: 0;
					}
						
				`}
			</style>
		</>

	);

};

export default Mobile;
